require( './bootstrap' );

import LazyLoad from "vanilla-lazyload";

(
	function ( $ ) {
		"use strict";

		$( document ).ready(
			function () {
				let btn = document.getElementById( 'loadmore' );

				if ( btn ) {
					loadMore();
				}

				function loadMore() {
					let btn_text = btn.textContent;

					btn.addEventListener(
						'click',
						function () {
							btn.disabled = true;
							btn.textContent = 'Load...';
							let request = new XMLHttpRequest();
							request.open( 'POST',
								ajaxurl + '?action=loadmore&query=' + true_posts + '&page=' + current_page, true );
							request.send();
							request.onload = function () {
								if ( request.status >= 200 && request.status < 400 ) {
									let resp = request.responseText;
									if ( resp && resp !== '0' ) {
										let div = document.createElement( "div" );
										div.innerHTML = resp;
										while ( div.firstChild ) {
											let item = div.removeChild( div.firstChild );
											btn.parentNode.parentNode.insertBefore( item, btn.parentNode );
										}
										if ( current_page == (
											max_pages
										) ) {
											btn.parentNode.style.display = 'none';
										}
										current_page ++;
										btn.textContent = btn_text;
										btn.disabled = false;
									} else {
										btn.parentNode.style.display = 'none';
										console.log( 'No response...' );
									}

								} else {
									console.log( 'Error...' );
								}
							};
							request.onerror = function () {
								console.log( 'Connection Error...' );
							};
						}
					);
				}

				let modal = document.getElementById( "modal-lang" );

				if ( modal ) {
					if ( getCookie( 'modal' ) === 'disable' ) {
						modal.remove();
					} else {
						modal.style.display = "flex";
					}

					$( 'body' ).on(
						'click',
						'#modal-lang a',
						function () {
							let mls = $( this ).data( 'mls' );
							addCookie();

							if ( 'ru' === mls ) {
								modal.remove();

								return false;
							}
						}
					);
				}

				hide_adminbar();
			}
		);

	}
)( jQuery );

function getCookie( name ) {
	let nameEQ = name + "=",
		ca = document.cookie.split( ';' );

	for ( let i in ca ) {
		let c = ca[i];
		while ( c.charAt( 0 ) == ' ' ) {
			c = c.substring( 1, c.length );
		}
		if ( c.indexOf( nameEQ ) == 0 ) {
			return c.substring( nameEQ.length, c.length );
		}
	}
	return null;
}

function addCookie() {
	document.cookie = "modal=disable; path=/";
}

/**
 * Hide admin bar from not auth users if it showed from cache
 */
function hide_adminbar() {
	let adminBar = document.getElementById( 'wpadminbar' );
	if ( adminBar ) {
		if ( 'undefined' === typeof userLoggedIn ) {
			adminBar.remove();
			document.getElementsByTagName( 'body' )[0].style.marginTop = '-32px';
		}
	}
}


// -----------------------------------------------------------------------------------------------//

document.addEventListener( "DOMContentLoaded", readyHTML );

function readyHTML() {
	adapt( '990', ['#menu-header-menu'], 'cover', '.insert_adapt_menu' );
}


function move_block( adaptWid, block_to_move, place_to_move ) {
	window.addEventListener( 'resize', _move_resizewindow );
	let place_to = document.querySelector( place_to_move );
	let block_to = document.querySelector( block_to_move );
	if ( block_to && place_to ) {
		let block = block_to.querySelector( 'ul' );
		let place = place_to.querySelector( 'ul' );
		if ( block ) {
			block.classList.add( 'block_to_move' );
		}
		if ( place ) {
			place.classList.add( 'place_to_move' );
		}
	}
	let wid = window.innerWidth;
	_move_resizewindow();

	function _move_resizewindow() {
		wid = window.innerWidth;
		let activeItems;
		if ( wid < adaptWid ) {
			let activeLiBlock = block.querySelectorAll( 'li' );
			let activeLiPlace = place.querySelectorAll( 'li' );
			if ( activeLiBlock ) {

			}
			if ( block && place ) {
				place_to.insertBefore( block, place );
			}
		} else {
			if ( block && place ) {
				let block_replaced = place_to.querySelector( '.block_to_move' );
				if ( block_replaced ) {
					block_to.appendChild( block_replaced );
				}
			}
		}
	}
}


function adapt( adaptWid, menu, covertable, insert_adapt_menu ) {
	window.addEventListener( 'resize', _resizewindow );
	if ( covertable && covertable != 'nocover' ) {
		_coverTable();
	}
	let body = document.querySelector( 'body' );

	function _coverTable() {
		let table = document.querySelectorAll( 'table' );
		for ( let i = table.length - 1; i >= 0; i -- ) {
			let cover = document.createElement( 'div' );
			cover.classList.add( 'cover-table' );
			table[i].parentNode.insertBefore( cover, table[i] );
			cover.appendChild( table[i] );
		}
	}

	let adapt_menu = [];
	if ( menu ) {
		for ( let l = 0; l < menu.length; l ++ ) {
			adapt_menu[l] = document.querySelectorAll( menu[l] );
		}
	}

	let adapt_menu_cover = document.createElement( 'div' );
	adapt_menu_cover.classList.add( 'cover-menu' );
	body.appendChild( adapt_menu_cover );
	adapt_menu_cover.classList.add( 'cover-menu' );
	document.querySelector( '.adapt-menu-wrp' ).appendChild( adapt_menu_cover );
	let gamburger = document.querySelector( '.adapt-menu-icon' );
	if ( !gamburger ) {
		let gamburger = document.createElement( 'div' );
		gamburger.classList.add( 'adapt-menu-icon' );
		gamburger.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
	}
	let gamburger2 = document.querySelector( '.show-menu-icon' );

	let bgicon = document.querySelector( '.icon-menu-bg' );
	if ( !bgicon ) {
		let bgicon = document.createElement( 'div' );
		bgicon.classList.add( 'icon-menu-bg' );
	}
	let closemenu = document.querySelector( '.menu-close-button' );
	if ( !closemenu ) {
		let closemenu = document.createElement( 'div' );
		closemenu.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
		closemenu.classList.add( 'menu-close-button' );
	}

	let menu_menu = document.querySelector( insert_adapt_menu );
	if ( gamburger && adapt_menu ) {
		if ( menu_menu ) {
			menu_menu.appendChild( gamburger );
		}

		gamburger.addEventListener( 'click', showmenu );
	}
	if ( gamburger2 && adapt_menu ) {
		body.appendChild( gamburger2 );
		gamburger2.addEventListener( 'click', showmenu );
	}
	if ( bgicon && adapt_menu ) {
		body.appendChild( bgicon );
		bgicon.addEventListener( 'click', hidemenu );
	}
	if ( closemenu && adapt_menu_cover ) {
		adapt_menu_cover.appendChild( closemenu );
		closemenu.addEventListener( 'click', hidemenu );
	}
	if ( adapt_menu_cover && adapt_menu ) {
		for ( let d = 0; d < adapt_menu.length; d ++ ) {
			for ( let f = 0; f < adapt_menu[d].length; f ++ ) {
				adapt_menu_cover.appendChild( adapt_menu[d][f].cloneNode( true ) );
			}
		}
	}
	let elements = adapt_menu_cover.querySelectorAll( '*' );
	for ( let e = 0; e < elements.length; e ++ ) {
		elements[e].removeAttribute( 'id' );
	}

	let menusss = document.querySelectorAll( ".cover-menu .menu-item-has-children" );
	for ( let i = 0; i < menusss.length; i ++ ) {
		let spanMenuTrigger = document.createElement( 'span' );
		spanMenuTrigger.setAttribute( 'class', 'note' );
		menusss[i].appendChild( spanMenuTrigger );
	}

	let acc = document.querySelectorAll( ".cover-menu .menu-item-has-children span" );
	for ( let i = 0; i < acc.length; i ++ ) {
		acc[i].addEventListener(
			"click",
			function () {
				event.stopPropagation();
				if ( this.parentElement.classList.contains( 'active' ) ) {
					this.parentElement.classList.remove( 'active' );
				} else {
					this.parentElement.classList.add( "active" );
				}
			}
		);
	}

	_resizewindow();

	function _resizewindow() {
		let wid = window.innerWidth;
		if ( wid < adaptWid ) {
			if ( gamburger ) {
				gamburger.addEventListener( 'click', showmenu );
			}
			if ( gamburger2 ) {
				gamburger2.addEventListener( 'click', showmenu );
			}
			if ( bgicon ) {
				bgicon.addEventListener( 'click', showmenu );
			}
			if ( closemenu ) {
				closemenu.addEventListener( 'click', hidemenu );
			}
		} else {
			if ( gamburger ) {
				gamburger.removeEventListener( 'click', showmenu );
				gamburger.classList.remove( 'activeGamburger' );
			}
			if ( gamburger2 ) {
				gamburger2.removeEventListener( 'click', showmenu );
			}
			if ( adapt_menu_cover ) {
				adapt_menu_cover.classList.remove( 'showmenu' );
			}
			if ( closemenu ) {
				closemenu.removeEventListener( 'click', hidemenu );
			}
			if ( bgicon ) {
				bgicon.classList.remove( 'showbg' );
				bgicon.removeEventListener( 'click', showmenu );
			}
			if ( body ) {
				body.classList.remove( 'OverflowHiden' );
			}
		}
	}

	function showmenu() {
		if ( gamburger ) {
			gamburger.removeEventListener( 'click', showmenu );
			gamburger.classList.add( 'activeGamburger' );
			gamburger.addEventListener( 'click', hidemenu );
		}
		if ( gamburger2 ) {
			gamburger2.removeEventListener( 'click', showmenu );
			gamburger2.addEventListener( 'click', hidemenu );
		}
		let scrolled = window.pageYOffset || document.documentElement.scrollTop;

		if ( adapt_menu_cover ) {
			adapt_menu_cover.classList.add( 'showmenu' );
		}
		if ( closemenu ) {
			closemenu.addEventListener( 'click', hidemenu );
		}
		if ( bgicon ) {
			bgicon.classList.add( 'showbg' );
			bgicon.addEventListener( 'click', showmenu );
		}
		if ( body ) {
			body.classList.add( 'OverflowHiden' );
		}
	}

	function hidemenu() {
		if ( gamburger ) {
			gamburger.addEventListener( 'click', showmenu );
			gamburger.classList.remove( 'activeGamburger' );
			gamburger.removeEventListener( 'click', hidemenu );
		}
		if ( gamburger2 ) {
			gamburger2.addEventListener( 'click', showmenu );
			gamburger2.removeEventListener( 'click', hidemenu );
		}
		if ( bgicon ) {
			bgicon.classList.remove( 'showbg' );
			bgicon.removeEventListener( 'click', showmenu );
		}
		if ( closemenu ) {
			closemenu.removeEventListener( 'click', hidemenu );
		}
		if ( adapt_menu_cover ) {
			adapt_menu_cover.classList.remove( 'showmenu' );
		}
		if ( body ) {
			body.classList.remove( 'OverflowHiden' );
		}
	}
}

// ----------------- Adaptive menu End --------------------//


// ----------------- FAQ Begin --------------------//
(
	function ( $ ) {
		'use strict';
		$( document ).ready(
			function () {
				$( '.accordion-wrapper__item .title' ).on(
					'click',
					function () {
						$( '.accordion-content' ).slideUp();

						if ( $( this ).hasClass( 'open' ) ) {
							$( '.accordion-wrapper__item .title' ).removeClass( 'open' )
							$( this ).next().slideUp();
							return false;
						} else {
							$( '.accordion-wrapper__item .title' ).removeClass( 'open' );
							$( this ).addClass( 'open' );
							$( this ).next().slideDown();
						}
						return false;
					}
				);
			}
		);

	}
)( jQuery );

document.addEventListener(
	'DOMContentLoaded',
	function () {
		let myLazyLoad = new LazyLoad( {
			elements_selector: ".lazy-load"
		} );
	}
);

/**
 * Loadmore from loadmore.min.js
 */
(
	function ( $ ) {
		$( '#true_loadmore' ).click( function () {
			$( this ).text( 'Загрузка...' );
			let data = {
				'action': 'loadmore',
				'query': true_posts,
				'page': current_page
			};
			$.ajax( {
				url: ajaxurl,
				data: data,
				type: 'POST',
				success: function ( data ) {
					if ( data ) {
						$( '#true_loadmore' ).text( 'Загрузить еще' );
						$( '.obj_row' ).before( data );
						current_page ++;
						if ( current_page == max_pages ) {
							$( "#true_loadmore" ).remove();
						}
					} else {
						$( '#true_loadmore' ).remove();
					}
				},
				complete: function () {
					let myLazyLoad = new LazyLoad( {
						elements_selector: ".lazy-load"
					} );
				}
			} );
		} );
	}
)( jQuery );
